import React, { useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  FlatList,
  TextInput,
  ScrollView,
} from "react-native";
import { useSelector, useDispatch } from "react-redux";
import { styles } from "../../style/styles.js";
import {
  updateInfoData,
  setTimerRunning,
  setIncidenceCounter,
} from "../../redux/reducers";
import {
  updateTemp,
  fullDataPiece,
  getListProblemSolution,
  setLog,
} from "../../services/ConnectDataBase.js";
import {
  getListOptionsTimeWork,
  getListOptionsStoneList,
  getCurrentDateTime,
  getArrayInfoDataUpdate,
  getStatusDelivery,
  getListOptionsProblemAndSolutions,
  correctWeight,
  formatTime,
  convertToMinutes,
} from "../../services/Functions.js";
import texts from "../../translations/texts.js";
import CustomPopup from "../Common/ComponentToast.js";
import { SCREEN_IDS } from "../FullComponent.js";
import { BACKGROUND_COLORS, TEXT_COLORS, STATUS_COLORS, BRAND_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

const Cronometro = ({ screen, listData, po, mo, id }) => {
  const dispatch = useDispatch();
  const eFabrica = useSelector((state) => state.eFabrica);
  const piedras = eFabrica.filter((item) => item.tipo === "PIEDRAS");
  const cantidad = useSelector((state) => state.cantidad.totalCantidad);
  const errorMessage = "No se pueden añadir más piezas que la cantidad total.";
  const [comentario, setComentario] = useState("");
  const [numImgLGD, setNumImgLGD] = useState("");
  const [numImgCVD, setNumImgCVD] = useState("");
  const [time, setTime] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [startTimeForServer, setStartTimeForServer] = useState(""); // Para el servidor

  const [isRunning, setIsRunning] = useState(false);
  const animationFrameRef = useRef(null);
  const infoData = useSelector((state) => state.infoData.infoData);
  const bruto = infoData.pesobruto;
  const intervalRef = useRef(null);
  const timerRef = useRef(null);
  const [createNewTime, setCretateNewTime] = useState(false);
  const [isSecondConfirmed, setIsSecondConfirmed] = useState(false);
  const [secondSelect, setSecondSelect] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [listOption, setListOption] = useState([]);
  const name = useSelector((state) => state.user.name);
  const team = useSelector((state) => state.user.team);
  const cod_team = useSelector((state) => state.user.cod_team);
  const [showModal, setShowModal] = useState(false);
  const [showPieceCountModal, setShowPieceCountModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const [showText, setShowText] = useState(false);
  const [showIncidencia, setShowIncidencia] = useState(false);
  const [incidenciaCount, setIncidenciaCount] = useState("");
  const [pieceCount, setPieceCount] = useState(cantidad);
  const [selectedOptionName, setSelectedOptionName] = useState(null);
  const [standardTime, setStandardTime] = useState("");
  const [firstSelected, setFirstSelected] = useState(false);
  const [firstNameSelected, setFirstNameSelected] = useState(false);
  const [firstIdSelected, setFirstIdSelected] = useState(false);
  const [showCustomPop, setShowCustomPop] = useState(false);
  const [estadoTiempo, setEstadoTiempo] = useState("");
  const [mensajeTiempo, setMensajeTiempo] = useState("");
  const lang = useSelector((state) => state.lang.value);
  const [isLGDChecked, setIsLGDChecked] = useState(false);
  const [isCVDChecked, setIsCVDChecked] = useState(false);
  const totalIncidenciaCount = useSelector(
    (state) => state.totalIncident.value
  );
  const [textInputStyle, setTextInputStyle] = useState({
    backgroundColor: "black",
    color: "white",
  });
  let Options = "";
  let OptionIncident = "";

  const showValidationMessage = (message, type = "warn") => {
    notify[type]?.(message);
  };

  let startsWithX = piedras.some((item) =>
    item.codigo.toLowerCase().startsWith("x")
  );

  // Filtrar las piedras que empiezan con "br"
  let startsWithBr = piedras.filter((item) =>
    item.codigo.toLowerCase().startsWith("br")
  );

  // Verificar si hay alguna piedra que cumple con el criterio
  let hasBrCodeWithDigitsGreaterThan10 = false;

  startsWithBr.forEach((item) => {
    const code = item.codigo.toLowerCase();
    if (code.length >= 4) {
      const thirdDigit = code[2];
      const fourthDigit = code[3];
      if (!isNaN(thirdDigit) && !isNaN(fourthDigit)) {
        const value = parseInt(thirdDigit + fourthDigit, 10);
        if (value > 10) {
          hasBrCodeWithDigitsGreaterThan10 = true;
        }
      }
    }
  });

  const tick = () => {
    const currentTime = performance.now();
    const elapsed = currentTime - startTime + elapsedTime;
    setTime(Math.floor(elapsed / 1000));
    if (isRunning) {
      animationFrameRef.current = requestAnimationFrame(tick);
    }
  };


  useEffect(() => {
    // Lógica de verificación de pantalla para las funcionalidades ya existentes
    if (screen === 9) {
      let status = "stoneStatus";
      let codePage = 7;
      getStatusDelivery(mo, codePage, status, po)
        .then((estado) => {
          setIsSecondConfirmed(estado[1]);
        })
        .catch((error) => {
          console.error(error);
          setIsSecondConfirmed(false);
        });
    }
    if (screen === 5 || screen === 8) {
      getListOptionsProblemQuality();
      let sum = 0;
      for (let i = 0; i < infoData.tiempos.length; i++) {
        const cantidadIncidencia = parseFloat(
          infoData.tiempos[i].cantidad_incidencia
        );
        if (!isNaN(cantidadIncidencia)) {
          sum += cantidadIncidencia;
        }
      }
      dispatch(setIncidenceCounter(sum));
    }

    if (isRunning) {
      animationFrameRef.current = requestAnimationFrame(tick);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current); // Limpia la animación cuando se pausa o desmonta el componente
      }
    };
  }, [isRunning, startTime]); // Dependencias: screen, isRunning, startTime

  async function getListOptionsProblemQuality() {
    try {
      const options = await getListProblemSolution(mo, 5, cod_team, "list");

      setListOption(options);
    } catch (error) {
      console.error(error);
    }
  }

  function checkNumberIncident(value) {
    const remainingPieces = cantidad - incidenciaCount;
    const inputValue = parseFloat(value, 10);
    const pieceCountInt = parseFloat(pieceCount, 10);

    if (isNaN(inputValue)) {
      // Si el valor no es un número válido, no hacemos nada
      return;
    }

    if (inputValue > remainingPieces) {
      showValidationMessage(
        "El valor introducido no puede ser mayor a la diferencia entre cantidad e incidencia."
      );
      return;
    } else {
      // El valor introducido es válido
      setIncidenciaCount(inputValue);
    }

    if (inputValue > pieceCountInt) {
      showValidationMessage("No puede haber mas incidencias que piezas realizadas");
      setTextInputStyle({
        backgroundColor: "red",
        color: "white",
      });
      return;
    }
    setTextInputStyle({
      backgroundColor: "black",
      color: "white",
    });
  }

  if (screen === 5) {
    Options = getListOptionsProblemAndSolutions(listOption);
  } else if (screen === 8) {
    Options = getListOptionsTimeWork(listData);

    OptionIncident = getListOptionsProblemAndSolutions(listOption);
  } else if (screen === 9) {
    Options = getListOptionsStoneList(listData);
  }

  const handleFunction = () => {
    if (screen === 5 && incidenciaCount === 0) {
      showValidationMessage("No puede iniciar una reparación, no hay incidencias");
      return;
    }
    if (screen != 5 && totalIncidenciaCount === cantidad) {
      showValidationMessage("Todas las piezas están en proceso: INCIDENCIA");
      return; // No se ejecuta nada si taller no confirma piedras
    } else if (totalIncidenciaCount > cantidad) {
      showValidationMessage(
        "Error, El numero de piezas con incidencia es superior a la cantidad de piezas",
        "error"
      );
      return;
    }
    if (screen === 9 && !isSecondConfirmed) {
      showValidationMessage("No se ha confirmado la recepción de piedras");
      return; // No se ejecuta nada si taller no confirma piedras
    }

    if (!createNewTime) {
      setCretateNewTime(true);

      setShowText(true);
    }

    if (
      (screen === 5 || screen === 8 || screen === 9) &&
      !showModal &&
      (!selectedOption || selectedOption.length === 0) && // Comprueba si no hay opciones seleccionadas
      !isRunning &&
      !showText
    ) {
      setShowModal(true);
      setFirstSelected(false);
      setShowText(true);
    } else {
      handleStartPause();
    }
  };


  const handleStartPause = () => {
    if (pieceCount <= cantidad) {
      if (isRunning) {
        // Pausa el cronómetro
        cancelAnimationFrame(animationFrameRef.current);
        setElapsedTime(
          (prevElapsed) => prevElapsed + (performance.now() - startTime)
        );
        setIsRunning(false);
      } else {
        // Inicia o reanuda el cronómetro
        setStartTime(performance.now()); // Establece el timestamp actual
        animationFrameRef.current = requestAnimationFrame(tick);
        setIsRunning(true);
        dispatch(setTimerRunning(true));
      }
    } else {
      setShowModal(false);
      setShowText(false);
      setSelectedOption(null);
      setPieceCount("1");
      setShowText(false);
      showValidationMessage("¡Has excedido el número de piezas!", "error");
    }
  };


  const handleStop = async () => {
    const formattedTime = formatTime(time);
    if (cod_team === "3" && startsWithX && !isLGDChecked && !showIncidencia) {
      showValidationMessage("Falta la comprobación LGD");
      return;
    }

    if (
      cod_team === "3" &&
      hasBrCodeWithDigitsGreaterThan10 &&
      !isCVDChecked &&
      !showIncidencia
    ) {
      showValidationMessage("Falta la comprobación CVD");
      return;
    }

    if (pieceCount <= cantidad && incidenciaCount <= pieceCount) {
      if (
        (showIncidencia === true && incidenciaCount > 0) ||
        showIncidencia === false
      ) {
        dispatch(setIncidenceCounter(incidenciaCount));

        let peso = "";
        let firstName = "";
        let firstId = "";

        // Verificación del peso antes de ejecutar correctWeight
        if (totalWeight > 0) {
          let totalW = correctWeight(totalWeight, bruto);
          if (!totalW) {
            showValidationMessage("Se han superado los márgenes de peso", "error");
            return; // Detener si el peso no es válido
          } else {
            peso = firstNameSelected === "CALIDAD" ? totalWeight : "";
          }
        }

        setShowPieceCountModal(false);
        clearInterval(intervalRef.current);
        clearTimeout(timerRef.current);
        setShowModal(false);
        setSelectedOption([]);
        setShowIncidencia(false);
        setIsRunning(false);
        dispatch(setTimerRunning(false));
        setShowText(false);
        setCretateNewTime(false);
        setTime(0);

        const formattedTime = formatTime(time);
        if (screen === 8) {
          firstName = firstNameSelected;
          firstId = firstIdSelected;
        }

        let tiempoWork = convertToMinutes(formattedTime);
        let tiempoTeorico = parseFloat(standardTime) * cantidad;
        if (tiempoTeorico > 0) {
          if (tiempoWork < tiempoTeorico) {
            setMensajeTiempo(
              "¡Genial! Tiempo por debajo de lo esperado. ¡Buen trabajo!"
            );
            setEstadoTiempo("A");
          } else if (
            tiempoWork > tiempoTeorico &&
            tiempoWork <= tiempoTeorico * 1.1
          ) {
            setMensajeTiempo(
              "Tiempo ligeramente superior al esperado, pero aún así, buen esfuerzo."
            );
            setEstadoTiempo("B");
          } else if (tiempoWork > tiempoTeorico) {
            setMensajeTiempo(
              "Tiempo superior al esperado. Veamos cómo podemos optimizarlo para la próxima vez."
            );
            setLog(
              SCREEN_IDS.GENERAL,
              "LOG",
              "Tiempos",
              "tiempo superior a lo esperado, usuario:" + name
            );
            setEstadoTiempo("C");
          }
          setShowCustomPop(true);
        }

        //  return;
        const solution = selectedOption.solucion;
        timerRef.current = setTimeout(async () => {
          await updateTemp(
            po,
            mo,
            formattedTime,
            screen,
            selectedOption,
            selectedOption.incidencia,
            name,
            team,
            pieceCount - incidenciaCount,
            startTimeForServer, // Usa la variable correcta
            incidenciaCount,
            firstName,
            firstId,
            peso,
            getCurrentDateTime(),
            comentario,
            numImgLGD,
            isLGDChecked,
            numImgCVD,
            isCVDChecked,
            solution ? solution : ""
          );
          const newInfo = await fullDataPiece(mo, 2);
          const infoData = getArrayInfoDataUpdate(newInfo);
          dispatch(updateInfoData(infoData));
        }, 1000);
      } else {
        showValidationMessage("Nº incidencias no puede ser 0");
      }
    } else {
      showValidationMessage(errorMessage, "error");
    }

    setIncidenciaCount(0);
  };

  const totalFinishedPieces = () => {
    setIsRunning(false);
    handleStartPause();
    setShowPieceCountModal(true);
  };

  const handleOptionSelect = (option) => {
    if (screen === 9) {
      const isSelected = selectedOption.some((item) => item.id === option.id);
      if (isSelected) {
        setSelectedOption((prevSelectedOptions) =>
          prevSelectedOptions.filter((item) => item.id !== option.id)
        );
      } else {
        setSelectedOption((prevSelectedOptions) => [
          ...prevSelectedOptions,
          option,
        ]);
      }
    } else {
      if (screen === 8 && !firstSelected) {
        setFirstNameSelected(option.name);
        setFirstIdSelected(option.id);
      }
      setStandardTime(option.tiempos);
      selectedOption.name = setSelectedOption(option);
      setSelectedOptionName(
        option.name ? (screen === 9 ? "ENGASTE" : option.name) : null
      );
    }
  };

  const handleModalAccept = () => {
    if (screen === 9) {
      if (selectedOption.length > 0) {
        setStartTimeForServer(getCurrentDateTime()); // Establece la fecha y hora para el servidor
        handleStartPause();
        setShowModal(false);
      } else {
        showValidationMessage("Debe seleccionar al menos una opción.");
      }
    } else {
      setStartTimeForServer(getCurrentDateTime());
      handleStartPause();
      setShowModal(false);
      setFirstSelected(true);
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setShowText(false);
    setSelectedOption([]); // Reiniciar como un array vacío en lugar de null
  };

  const renderItem = ({ item }) => {
    const isScreen5 = screen === 5;
    const isScreen9 = screen === 9;
    const isSelected = isScreen9
      ? selectedOption.some((option) => option.id === item.id)
      : selectedOption && selectedOption.id === item.id;
    const isSecondSelect = secondSelect.id === item.id;
    // Verifica si el secondSelect coincide con el ID del item actual
    const optionItemStyle = [
      styles.optionItem,
      (isSelected || isSecondSelect) && styles.selectedOptionItem,
    ];
    const optionTextStyle = [
      styles.optionText,
      (isSelected || isSecondSelect) && styles.selectedOptionText,
      { alignItems: "center", textAlign: "center" },
    ];

    return (
      <TouchableOpacity
        style={optionItemStyle}
        onPress={() => handleOptionSelect(item)}>
        <Text style={optionTextStyle}>
          {isScreen5
            ? `${item.name} - ${item.descsol}`
            : isScreen9
            ? item.id
            : item.name}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <View style={[styles.row, { padding: 8 }]}>
        <View style={styles.timerRowContainer}>
        <TouchableOpacity
          style={[
            isRunning
              ? styles.buttonPreStartProcessCustom
              : styles.buttonStartProcessCustom,
          ]}
          onPress={handleFunction}>
          <Text style={[styles.buttonTextCustom, styles.textColorCustom]}>
            {isRunning
              ? texts.MenuWork.buttonPause[lang]
              : texts.MenuWork.buttonStart[lang]}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            isRunning
              ? styles.buttonFinishProcessCustom
              : styles.buttonPreStopProcessCustom,
          ]}
          onPress={totalFinishedPieces}>
          <Text style={[styles.buttonTextCustom, styles.textColorCustom]}>
            {texts.MenuWork.buttonStop[lang]}
          </Text>
        </TouchableOpacity>
                        <View style={[styles.timerCountCustom, { backgroundColor: BACKGROUND_COLORS.SECONDARY }]}>
                  <Text style={[styles.buttonTextCustom, { color: TEXT_COLORS.DARK }]}>
            {formatTime(time)}
          </Text>
        </View>
        {showText && (
          <View
                            style={[styles.timerCountCustom, { backgroundColor: STATUS_COLORS.SUCCESS }]}>
            <Text style={[styles.buttonTextCustom, styles.textColor]}>
              {selectedOptionName
                ? selectedOptionName
                : screen === 9
                ? "ENGASTE"
                : ""}{" "}
              Ts:{" "}
              {parseFloat(standardTime)
                ? parseFloat(standardTime) * cantidad
                : 0}{" "}
              min.
            </Text>
          </View>
        )}
      </View>

      <Modal visible={showModal} animationType='fade' transparent>
        <View style={styles.modalContainer}>
          <View style={[styles.modalContent, { maxHeight: "80%" }]}>
            <Text style={styles.modalText}>Selecciona una opción:</Text>
            <FlatList
              data={Options}
              renderItem={renderItem}
              keyExtractor={(item) => item.id.toString()}
            />
            <View style={styles.buttonModalContainer}>
              <TouchableOpacity onPress={handleModalAccept}>
                <Text style={styles.modalText}>Aceptar</Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={handleModalCancel}>
                <Text style={styles.modalText}>Cancelar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Modal visible={showPieceCountModal} animationType='fade' transparent>
        <View style={[styles.modalContainer]}>
          <View style={styles.modalContent}>
            <Text style={styles.modalText}>Nº de piezas terminadas:</Text>
            <Text style={styles.modalTextSub}>(0 si no se ha terminado)</Text>
            <TextInput
              style={[styles.modalText, { backgroundColor: "black" }]}
              value={
                screen === 5
                  ? incidenciaCount === ""
                    ? ""
                    : incidenciaCount.toString()
                  : pieceCount === ""
                  ? ""
                  : pieceCount.toString()
              }
              onChangeText={(value) => {
                if (value === "") {
                  // Si el campo se borra, establecer el valor en cadena vacía
                  screen === 5 ? setIncidenciaCount("") : setPieceCount("");
                } else {
                  const parsedValue = value;
                  if (parsedValue > cantidad) {
                    // Valor ingresado mayor que la cantidad total, mostrar alerta y borrar el contenido
                    showValidationMessage(
                      "El valor no puede ser mayor que la cantidad total."
                    );
                    screen === 5 ? setIncidenciaCount("") : setPieceCount("");
                  } else {
                    // Valor válido, establecer el valor en entero
                    screen === 5
                      ? setIncidenciaCount(parsedValue)
                      : setPieceCount(parsedValue);
                  }
                }
              }}
              keyboardType='numeric'
            />
            {(cod_team === "3" || cod_team === "10" || cod_team === "11") && (
              <View>
                <TextInput
                  style={[styles.modalText, { backgroundColor: "black" }]}
                  placeholder='...'
                  onChangeText={(value) => {
                    setComentario(value);
                  }}
                />
                {startsWithX && (
                  <View style={styles.incidenciaRow}>
                    <Text style={styles.modalTextIncidencia}>LGD:</Text>
                    <TouchableOpacity
                      style={styles.incidenciaCheckbox}
                      onPress={() => setIsLGDChecked(!isLGDChecked)}>
                      {isLGDChecked ? (
                        <Text
                          style={[
                            styles.modalTextIncidenciaCheckBox,
                            { backgroundColor: STATUS_COLORS.SUCCESS_LIGHT },
                          ]}>
                          ✓
                        </Text>
                      ) : (
                        <Text
                          style={[
                            styles.modalTextIncidenciaCheckBox,
                            { backgroundColor: BRAND_COLORS.PRIMARY },
                          ]}></Text>
                      )}
                    </TouchableOpacity>
                    <TextInput
                      style={[
                        styles.modalText,
                        {
                          backgroundColor: "black",
                          width: 100,
                          marginLeft: 50,
                        },
                      ]}
                      placeholder='..'
                      onChangeText={(value) => {
                        setNumImgLGD(value);
                      }}
                    />
                  </View>
                )}
                {hasBrCodeWithDigitsGreaterThan10 && (
                  <View style={styles.incidenciaRow}>
                    <Text style={styles.modalTextIncidencia}>CVD:</Text>
                    <TouchableOpacity
                      style={styles.incidenciaCheckbox}
                      onPress={() => setIsCVDChecked(!isCVDChecked)}>
                      {isCVDChecked ? (
                        <Text
                          style={[
                            styles.modalTextIncidenciaCheckBox,
                            { backgroundColor: STATUS_COLORS.SUCCESS_LIGHT },
                          ]}>
                          ✓
                        </Text>
                      ) : (
                        <Text
                          style={[
                            styles.modalTextIncidenciaCheckBox,
                            { backgroundColor: BRAND_COLORS.PRIMARY },
                          ]}></Text>
                      )}
                    </TouchableOpacity>
                    <TextInput
                      style={[
                        styles.modalText,
                        {
                          backgroundColor: "black",
                          width: 100,
                          marginLeft: 50,
                        },
                      ]}
                      placeholder='..'
                      onChangeText={(value) => {
                        setNumImgCVD(value);
                      }}
                    />
                  </View>
                )}
              </View>
            )}

            {screen === 8 && (
              <View style={styles.incidenciaContainer}>
                <View style={styles.incidenciaRow}>
                  <Text style={styles.modalTextIncidencia}>Incidencia:</Text>
                  <TouchableOpacity
                    style={styles.incidenciaCheckbox}
                    onPress={() => setShowIncidencia(!showIncidencia)}>
                    {showIncidencia ? (
                      <Text
                        style={[
                          styles.modalTextIncidenciaCheckBox,
                          { backgroundColor: STATUS_COLORS.SUCCESS_LIGHT },
                        ]}>
                        ✓
                      </Text>
                    ) : (
                      <Text
                        style={[
                          styles.modalTextIncidenciaCheckBox,
                          { backgroundColor: BRAND_COLORS.PRIMARY },
                        ]}></Text>
                    )}
                  </TouchableOpacity>
                </View>
                {showIncidencia && (
                  <View>
                    <View style={styles.incidenciaRow}>
                      <Text style={styles.modalTextIncidencia}>Nº piezas:</Text>
                      <TextInput
                        style={[styles.modalText, textInputStyle]}
                        value={incidenciaCount.toString()}
                        onChangeText={(value) => {
                          setIncidenciaCount(value);
                          checkNumberIncident(value);
                        }}
                        keyboardType='numeric'
                      />
                    </View>
                    <Text style={styles.modalText}>Selecciona una opción:</Text>
                    <View style={{ height: "120pt", overflow: "hidden" }}>
                      <FlatList
                        data={OptionIncident}
                        renderItem={renderItem}
                        keyExtractor={(item) => item.id}
                        // no es necesario aplicar un estilo de maxHeight al FlatList
                      />
                    </View>
                  </View>
                )}
              </View>
            )}
            <TouchableOpacity onPress={handleStop}>
              <Text style={styles.modalText}>Aceptar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
      {showCustomPop && (
        <CustomPopup
          message={mensajeTiempo}
          tiempo={estadoTiempo}
          isVisible={showCustomPop}
          onHide={() => setShowCustomPop(false)} // Cambia el estado para esconder el popup
        />
      )}
    </View>
  );
};

export default Cronometro;
